import React from 'react';
import { Container } from 'semantic-ui-react';
import { SocialLinks } from 'volto-social-settings';
import {
  HeaderWhishlist,
  HeaderSearch,
  HeaderTopLink,
  HeaderTopRightMore,
} from 'iovisit-theme/components/layout';
import { LanguageSelector } from '@plone/volto/components';
import config from '@plone/volto/registry';

const HeaderTop = () => {
  return (
    <div className="iv--header-top">
      <Container>
        <div className="iv--header-top-wrapper">
          <div className="iv--header-top-left">
            <HeaderTopLink />
          </div>

          <div className="iv--header-top-right">
            <HeaderTopRightMore />
            <SocialLinks />
            <div className="iv--header-tools">
              <LanguageSelector />
              {/*
            {!token && (
              <div className="iv--tools">
                <Anontools />
              </div>
            )} */}
              {config.settings.showWishlistWidget && <HeaderWhishlist />}
              <HeaderSearch />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HeaderTop;
